﻿﻿export interface IDashContactDue {
    id: number;
    source: string;
    name: string;
    contactBy: string;
    intendedRecipientName: string;
    intendedRecipientDoB: string;
    donorCoordinator: string;
}
